import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardCardComponent } from './components/dashboard-card/dashboard-card.component';
import { DashboardComponent } from './components/dashboard.component';
import { DashboardHeroComponent } from './components/dashboard-hero/dashboard-hero.component';
import { DisclaimerSectionComponent } from './components/disclaimer-section/disclaimer-section.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { UpgradeCalloutComponent } from './components/upgrade-callout/upgrade-callout.component';
import { CallToActionSectionComponent } from './components/call-to-action-section/call-to-action-section.component';
import { PerkComponent } from './components/perk/perk.component';
import { DeviceComponent } from './components/device/device.component';
import { BannerSectionComponent } from './components/banner-section/banner-section.component';
import { PendingTestComponent } from './components/pending-test/pending-test.component';
import { ConnectedDevicesComponent } from './components/connected-devices/connected-devices.component';

@NgModule({
  declarations: [
    DashboardCardComponent,
    DashboardComponent,
    DashboardHeroComponent,
    DisclaimerSectionComponent,
    UpgradeCalloutComponent,
    CallToActionSectionComponent,
    PerkComponent,
    DeviceComponent,
    BannerSectionComponent,
    PendingTestComponent,
    ConnectedDevicesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class DashboardModule { }
